import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { config } from "../api/api";
import { set } from "date-fns";

import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MotorInsPaymentCancel = () => {
   const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
    
      const { t } = useTranslation();
  const base_url = config.baseURL;
  const [vendorkey,setVendorkey] = useState('');
  const [openMessageBox, setOpenMessageBox] = useState(false);
  //  const vendorKey="U1VQRVJKRVRAJF4q";

  const [policyStatus, setPolicyStatus] = useState();
  const [docFiles,setDocFiles]=useState()
  const [loading, setLoading] = useState(false);

  const urlSearchString = window.location.search;
  const uparams = new URLSearchParams(urlSearchString);
    const [policyDetails, setPolicyDetails] = useState(null);

      const search_quote = async (quoteNo) => {
    try {
     
      const payload = {
        civilId: "",
        plateNo: "",
        registrationMark: "",
        srcBusId: "SJET",
        txnTyp: "Q",
        mobileNo: "",
        policyNo: "",
        quoteNo: quoteNo,
        searchTyp: "",
      };

      const response = await fetch(base_url + "/search_quote", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vendorkey,
        },

        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("API request failed");
      const data = await response.json();
     

      if (data.message == "success") {
        return data;
      } else {
        console.log("order id not found");
      }
    } catch (error) {
      console.log("Error in API fetch", error);
    } 
  };

 useEffect(() => {

      const postvData = { organization_name: "Superjet" };

      if (vendorkey === '' || vendorkey === null || vendorkey === undefined) {
      
        
        fetch(base_url+'/create_organization', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(postvData),
          })
          .then(response => response.json())
          .then(data => {
            
            setVendorkey(data.result[0].vendor_key);
            console.log(data.result[0].vendor_key,"vk1")
          })
          .catch(error => {
              console.error('Error posting data:', error);
          });


      }
    }, [vendorkey]); 
  
  
  const fetchData = async (quoteNo) => {
    try {
       console.log(vendorkey,"vk")
      const payload = {
        quoteNo: quoteNo,
      };

      const response = await fetch(base_url + "/get_motor_policy_details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + vendorkey,
        },

        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("API request failed");
      const data = await response.json();

      if (data.message == "success") {
        return data;
      } else {
        console.log("data not found");
      }
    } catch (error) {
      console.log("Error in API fetch", error);
    }
  };
  


const handleRetryPayment=async(e)=>{
  // payment api 
  debugger
  e.preventDefault();

      const payment_data={
      "quoteNo":policyStatus?.result?.renewalQuoteNo || policyStatus?.result?.transactionDetails?.quoteNo,
      "amount": policyDetails?.result?.premium_amount || policyStatus?.result?.premiumAmt
  }
  
    const response = await fetch(base_url+"/motor_ins_payments",{
    method:"POST",
    headers:{
      "Authorization": `Bearer ${vendorkey}`,
      "Content-Type": "application/json"
    },
    body:JSON.stringify(payment_data)
  });
  if(!response.ok){
    console.log("payment fetch HTTP status :", response.status);
    }
  
    const payment_response = await response.json();
  
    if(payment_response.message==="success"){
  
      if(payment_response.result.success && payment_response.result.message==="Payment Link Generated Successfully" ){
  
        const url = payment_response.result.data
  
        if(url){
  
            window.location.href=url;
        }
  
      }
    }
    else{
      toast.error("Payment process not initiated");
    }
  
}




useEffect(() => {
  const fetchAndSetData = async () => {
    try {
      setLoading(true);

      const quoteNo = uparams.get("quote_no");
      if (!vendorkey || !quoteNo) return;

      const fetchedData = await fetchData(quoteNo);
      setPolicyDetails(fetchedData);

       const searchQuote = await search_quote(quoteNo);
setPolicyStatus(searchQuote);
    
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
if(vendorkey){
  fetchAndSetData();
}
}, [vendorkey]);





  return (
    <>
    
      <div className="header_section1">
        <Navbar />

        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{t("Payment Failed")}</h3>
          </div>
        </div>
      </div>

      <div className="features_section">
        <div className="container mt-5">
       { <div className="row  d-flex  justify-content-center">
            
            <div className=" col-lg-6 mt-3">
              <div className="  ">
                { policyStatus && 
                <>
                <table style={{width:"100%"}}>
                    <tbody>
                      <tr>
                        <td><b>{t("Quote No")}</b></td>
                        <td>:</td>
                        <td className="pl-2">
                          {policyStatus?.result.transactionDetails?.quoteNo}
                        </td>
                      </tr>

                      <tr>
                        <td><b>{t("Cover From Date")}</b></td>
                        <td>:</td>
                        <td className="pl-2">
                          {policyStatus?.result.effectiveDt}
                        </td>
                      </tr>

                      <tr>
                        <td><b>{t("Cover To Date")}</b></td>
                        <td>:</td>
                        <td className="pl-2">
                          {policyStatus?.result.expirationDt}
                        </td>
                      </tr>

                      <tr>
                        <td><b>{t("Insured Name")}</b></td>
                        <td>:</td>
                        <td className="pl-2">
                          {policyStatus?.result.insuredDetails.insureFullName}
                        </td>
                      </tr>

                      <tr>
                        <td><b>{t("Product")}</b></td>
                        <td>:</td>
                        <td className="pl-2">{policyStatus?.result.prodId}</td>
                      </tr>

                      <tr>
                        <td><b>{t("Plan")}</b></td>
                        <td>:</td>
                        <td className="pl-2">
                          {policyStatus?.result.planSelection}
                        </td>
                      </tr>

                      <tr>
                        <td><b>{t("Fee")}</b></td>
                        <td>:</td>
                        <td className="pl-2">
                          {policyStatus?.result.premiumAmt?policyStatus?.result.premiumAmt +" OMR" :""}
                        </td>
                      </tr>

                      <tr>
                        <td><b>{t("Payment Status")}</b></td>
                        <td>:</td>
                        <td className="pl-2">
                          {policyStatus?.result.premiumAmt?
                            policyDetails?.result?.payment_status:""
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>

                    {
      policyDetails?.payment_Status !=="success" ?
      <div className="mt-2"> <button type="button " className="mt-3 btn btn-primary" onClick={(e)=>handleRetryPayment(e)}>
        {t("Retry Payment")}</button>
      </div>:
      ""
    }

    </> 
}
              </div>
            </div>

          </div>
        } 
        </div>
      </div>

      <Footer />
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
};

export default MotorInsPaymentCancel;
